import { create } from "zustand"
import { createJSONStorage, persist } from "zustand/middleware"

interface UIState {
  isSidebarCollapsed: boolean
  toggleSidebar: () => void
}

export const useUIStore = create(
  persist<UIState>(
    (set) => ({
      isSidebarCollapsed: false, // O estado padrão é o menu expandido
      toggleSidebar: () =>
        set((state) => ({ isSidebarCollapsed: !state.isSidebarCollapsed })),
    }),
    {
      name: "ui-storage", // Nome da chave no localStorage
      storage: createJSONStorage(() => localStorage),
    },
  ),
)